import _regeneratorRuntime from "C:\\Projects\\@github\\@loopmode\\markdown\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "C:\\Projects\\@github\\@loopmode\\markdown\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import React from 'react';
import { applyPrism, getLanguageClassName, getThemeClassName } from '@codeblock/core';
import { getAutoload, setAutoload } from '@codeblock/core/lib/http';
import emptyLanguageProvider from '@codeblock/languages/lib/empty';
import createHttpThemeProvider from '@codeblock/themes/lib/utils/create-http-provider';
export function usePrism(elementRef, props) {
  var languageClassName = getLanguageClassName(props.language);
  var themeClassName = useThemeLoader({
    providers: props.providers,
    theme: props.theme
  });
  var dependencies = [props.language, props.async, props.onHighlight, props.onHighlightError, props.parallel, props.providers, props.children];
  React.useEffect(function () {
    if (elementRef.current && props.providers) {
      applyPrism(elementRef.current, {
        async: props.async,
        onHighlight: props.onHighlight,
        onHighlightError: props.onHighlightError,
        parallel: props.parallel,
        providers: props.providers
      });
    }
  }, dependencies);
  return {
    languageClassName: languageClassName,
    themeClassName: themeClassName
  };
}
export function useThemeLoader(props) {
  var _this = this;

  var _React$useState = React.useState(getThemeClassName(props.theme)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      className = _React$useState2[0],
      setClassName = _React$useState2[1];

  React.useEffect(function () {
    (function () {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _a, themeLoader, themeClassName;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                themeLoader = (_a = props.providers) === null || _a === void 0 ? void 0 : _a.themes[props.theme];
                themeClassName = getThemeClassName(props.theme);

                if (!(typeof themeLoader === 'function')) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return themeLoader();

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);
                process.env.NODE_ENV !== 'production' && console.error(_context.t0);

              case 11:
                setClassName(themeClassName);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 8]]);
      }));
    })();
  }, [props.theme, props.providers]);
  return className;
}
var httpPathProviderMapping = {};
export function useHTTPProviders(prismPath, defaultHttpThemeProvider) {
  var _React$useState3 = React.useState(prismPath === undefined || prismPath === getAutoload()),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isReady = _React$useState4[0],
      setReady = _React$useState4[1];

  React.useEffect(function () {
    setAutoload(prismPath);
    setReady(true);
  }, [prismPath]);

  if (!httpPathProviderMapping[prismPath]) {
    httpPathProviderMapping[prismPath] = {
      usePrismAutoload: true,
      languages: emptyLanguageProvider,
      themes: prismPath ? createHttpThemeProvider(prismPath) : defaultHttpThemeProvider
    };
  }

  return isReady ? httpPathProviderMapping[prismPath] : null;
}